import { gql, useQuery } from '@apollo/client';

import { StandaloneReportData } from '../types/kb';
import { useSpecialty, useVersion } from './useVersion';

const GET_STANDALONE_REPORTS_QUERY = gql`
  query StandaloneReports($version: Float!, $specialty: String) {
    standaloneReports(
      where: { version: { eq: $version }, specialty: { eq: $specialty } }
    ) {
      id
      classification
      value
      concatenate
      quote
      indent
      level
      new
      questionnaire
      documentKey
      condition
      explanationsConnection {
        edges {
          properties {
            condition
          }
          node {
            id
            value
            level
          }
        }
      }
    }
  }
`;

export const useStandaloneReports = (forceRefresh?: boolean) => {
  const version = useVersion();
  const specialty = useSpecialty();

  const { data } = useQuery<StandaloneReportData>(
    GET_STANDALONE_REPORTS_QUERY,
    {
      onError: console.log,
      variables: { version, specialty, forceRefresh },
    },
  );

  // Transform explanationsConnection to explanations[]; return undefined when none present
  const raw = data?.standaloneReports;
  if (!raw?.length) return undefined;

  return raw.map((report) => {
    const edges = report.explanationsConnection?.edges;
    const explanations = !edges?.length
      ? undefined
      : edges.map((edge) => ({
          ...edge.node,
          condition: edge.properties?.condition,
        }));
    return { ...report, explanations };
  });
};
